import type { LogFn } from '../log.js';
import { resetCliImmediateShutdownForTests } from '../runtime/cli-process-interrupt.js';
import { ensureCliSqliteParentDir, getCliSqlitePath } from './cli-sqlite-paths.js';
import { createSqliteDatabaseAccess } from './access/index.js';
import { importCliSqliteLegacyDiskData } from './legacy_migration/import-cli-legacy-disk-data.js';
import { migrateCliSqlite } from './migrate-cli-sqlite.js';
export { CliSqliteInterrupted, isCliSqliteLockError } from './sqlite-errors.js';

export type GetCliDatabaseOptions = {
  /** When opening the DB, emit start/finish lines around legacy disk import only if legacy files are pending. */
  logLegacyMigration?: LogFn;
};

const cliSqlite = createSqliteDatabaseAccess<GetCliDatabaseOptions>({
  getPath: getCliSqlitePath,
  ensureParentDir: ensureCliSqliteParentDir,
  migrate: migrateCliSqlite,
  afterOpen: (db, options) => {
    importCliSqliteLegacyDiskData(db, options?.logLegacyMigration);
  },
});

/** Close a WASM SQLite handle without throwing (node-sqlite3-wasm can throw on double-close or bad state). */
export const safeCloseCliSqliteDatabase = cliSqlite.safeClose;

/** No-op: fresh connection per access call. Kept for bridge shutdown, corrupt-index recovery, and tests. */
export const closeAllCliSqliteConnections = cliSqlite.closeAllConnections;

/** @alias Vitest and callers that only need teardown semantics */
export function closeCliDatabaseForTests(): void {
  resetCliImmediateShutdownForTests();
}

export const openCliSqliteConnection = cliSqlite.openConnection;
export const withCliSqliteSync = cliSqlite.withSync;
export const withCliSqlite = cliSqlite.withAsync;
export const ensureCliSqliteInitialized = cliSqlite.ensureInitialized;
